// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerA_TheComp__C_A2J"};